import { boot } from 'quasar/wrappers'
import { configure, useI18n } from 'booksprout-app'

/**
 * vue-i18n 9. Three things changed from v8 and all of them are here:
 *
 *   - `new VueI18n(...)` is now `createI18n(...)`, and what comes back is the app-level instance;
 *     the translator lives on its `.global` (see i18nModule's `init`).
 *   - there is no `Vue.use()`. The instance is a plugin installed on the app: `app.use(i18n)`.
 *   - `$t` reaches templates through `globalInjection`, set in the shared options rather than here.
 */
export default boot(({ app }) => {
  // One instance per request, created in the `bootstrap` boot file - see i18nModule for why this
  // cannot live at module scope.
  //
  // This app deliberately ignores the reader's bs-locale cookie and stays on en-US. All four apps
  // sit on one host under path prefixes, so the cookie reaches this one too - but only the reader
  // side has been translated, and honouring it here would render a half-Spanish dashboard where
  // the shared strings are translated and this app's own strings are not. Drop this override once
  // this app has locale files of its own.
  const i18n = useI18n().plugin()

  // Without its components: `configure` registers them, so `i18n-t` renders a span as Vue 2's `<i18n>` did.
  app.use(i18n, { globalInstall: false })
  configure(i18n, app)
})
